<app-auth-error-display [type]="type" [message]="message" [attemptedUrl]="attemptedUrl"></app-auth-error-display>
